import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import { useProgressBar } from '@react-aria/progress';

var Progress = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$label = props.label,
      label = _props$label === void 0 ? 'Loading' : _props$label,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      indeterminate = props.indeterminate,
      _props$position = props.position,
      position = _props$position === void 0 ? 'relative' : _props$position,
      _props$zIndex = props.zIndex,
      zIndex = _props$zIndex === void 0 ? 'z-0' : _props$zIndex,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? 'bg-gray-200' : _props$backgroundColo,
      _props$borderRadius = props.borderRadius,
      borderRadius = _props$borderRadius === void 0 ? 'rounded-full' : _props$borderRadius,
      _props$height = props.height,
      height = _props$height === void 0 ? 'h-1' : _props$height,
      _props$width = props.width,
      width = _props$width === void 0 ? 'w-full' : _props$width,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'text-blue-500' : _props$textColor,
      translate = props.translate,
      rest = _objectWithoutPropertiesLoose(props, ["label", "min", "max", "value", "indeterminate", "position", "zIndex", "backgroundColor", "borderRadius", "height", "width", "textColor", "translate"]);

  var _useProgressBar = useProgressBar({
    label: label,
    value: value ? Number(value) : undefined,
    minValue: 0,
    maxValue: Number(max),
    isIndeterminate: indeterminate
  }),
      progressBarProps = _useProgressBar.progressBarProps; // Calculate the width of the progress bar as a percentage


  var percentage = (value - min) / (max - min);
  return React__default.createElement(Box, _extends({
    ref: ref
  }, progressBarProps, {
    position: position,
    zIndex: zIndex,
    height: height,
    width: width,
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    textColor: textColor,
    translate: translate
  }, rest, {
    overflow: "overflow-hidden"
  }), React__default.createElement(Box, {
    height: "h-full",
    backgroundColor: "bg-current",
    borderRadius: "rounded-inherit",
    transitionProperty: "transition-all",
    transitionDuration: "duration-200",
    style: {
      width: indeterminate ? '25%' : Math.round(percentage * 100) + "%"
    },
    animation: indeterminate ? 'animate-progress-indeterminate' : undefined
  }));
});

if (__DEV__) {
  Progress.displayName = 'Progress';
}

export default Progress;
//# sourceMappingURL=index.esm.js.map
